import { fuzzyDateParse } from "../../util.js";
import { createMappingWarning, isValidEmail, isValidPhoneNumber, mapGender, mapIso3166, } from "../utils.js";
export function mapMyNlGovernmentToCustomer(govData) {
    const errors = [];
    const warnings = [];
    const personDetails = {
        firstName: govData.firstName,
        infix: govData.infix || undefined,
        lastName: govData.lastName,
        birthDate: fuzzyDateParse(govData.dateOfBirth, {
            twoDigitYearCentury: "past",
        }).toISODate() ?? undefined,
        gender: mapGender(govData.gender),
    };
    const residence = {
        streetName: govData.streetAndHouseNumber,
        postcode: govData.postalCode,
        place: govData.municipality,
        country: "NL Nederland",
    };
    const otherDetails = {
        birthPlace: govData.placeOfBirth,
        // birthCountry: mapCountry(govData.countryOfBirth),
        // nationality: mapNationality(govData.nationality?.[0]?.nationality),
    };
    if (!govData.partner) {
        otherDetails.maritalStatus = {
            situation: "single",
        };
    }
    else {
        const partnershipType = govData.partner.partnershipType?.toLowerCase();
        if (partnershipType?.includes("gehuwd") ||
            partnershipType?.includes("married")) {
            otherDetails.maritalStatus = {
                situation: "married",
                details: { terms: "shared property" },
            };
        }
        else if (partnershipType?.includes("partnerschap") ||
            partnershipType?.includes("partnership")) {
            otherDetails.maritalStatus = {
                situation: "partnership",
                details: { terms: "shared property" },
            };
        }
    }
    if (govData.previousPartners) {
        const hasPreviousMarriage = govData.previousPartners.some((partner) => partner.partnershipType?.toLowerCase().includes("gehuwd"));
        const hasPreviousPartnership = govData.previousPartners.some((partner) => partner.partnershipType?.toLowerCase().includes("partnerschap"));
        const mostRecentEnddate = govData.previousPartners.reduce((red, partner) => {
            const enddate = fuzzyDateParse(partner.partnershipEndDate);
            if (enddate?.isValid && (red === undefined || enddate > red)) {
                return enddate;
            }
            return red;
        }, undefined);
        otherDetails.formerMaritalStatus ??= {
            hasFormerStatus: govData.previousPartners.length > 0,
            date: mostRecentEnddate?.toISODate(),
            kind: hasPreviousMarriage && hasPreviousPartnership
                ? "03 Beide"
                : hasPreviousMarriage
                    ? "01 Huwelijk"
                    : hasPreviousPartnership
                        ? "02 Geregistreerd partnerschap"
                        : undefined,
        };
    }
    if (!personDetails.gender) {
        warnings.push(createMappingWarning("myNlGovernment.gender", `Could not map gender value: ${govData.gender}`, govData.gender));
    }
    const customer = {
        personDetails,
        residence,
        otherDetails,
        contactDetails: {},
        identification: {},
    };
    return { customer, errors, warnings };
}
export function mapIdinToCustomer(idin) {
    const errors = [];
    const warnings = [];
    const personDetails = {
        initials: idin.initial,
        infix: idin.infix || undefined,
        lastName: idin.surname,
        birthDate: fuzzyDateParse(idin.dateOfBirth, {
            twoDigitYearCentury: "past",
        }).toISODate() ?? undefined,
        gender: mapGender(idin.gender),
    };
    const contactDetails = {};
    if (idin.email) {
        if (isValidEmail(idin.email)) {
            contactDetails.email = idin.email;
        }
        else {
            warnings.push(createMappingWarning("idin.email", `Invalid email format: ${idin.email}`, idin.email));
        }
    }
    if (idin.phoneNumber) {
        if (isValidPhoneNumber(idin.phoneNumber)) {
            contactDetails.tel = idin.phoneNumber;
        }
        else {
            warnings.push(createMappingWarning("idin.phoneNumber", `Invalid phone number format: ${idin.phoneNumber}`, idin.phoneNumber));
        }
    }
    const residence = {
        streetName: idin.street,
        housenumber: idin.houseNumber,
        postcode: idin.postalCode,
        place: idin.city,
        country: mapIso3166(idin.country),
    };
    if (!personDetails.gender) {
        warnings.push(createMappingWarning("idin.gender", `Could not map gender value: ${idin.gender}`, idin.gender));
    }
    const customer = {
        personDetails,
        contactDetails,
        residence,
        otherDetails: {},
        identification: {},
    };
    return { customer, errors, warnings };
}
